import {
  Modal,
  Box,
  TextField,
  Button,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  CircularProgress,
  Alert,
} from "@mui/material";
import { useState } from "react";
import { useGetEmployeeListQuery } from "../../../services/invoices/InvoiceApiSlice";

const ApproverModal = ({ modalAction, setIsModalOpen, handleSubmit }) => {
  const {
    data: employeeData,
    isLoading: isEmployeeDataLoading,
    isError: isEmployeeDataError,
    error: employeeDataError,
    refetch: employeeDataRefetch,
  } = useGetEmployeeListQuery(null, {
    skip: modalAction !== "assign-approver",
  });

  const [remarks, setRemarks] = useState<string>("");
  const [selectedApproverId, setSelectedApproverId] = useState<string>(null);

  const resetForm = () => {
    setRemarks("");
    setSelectedApproverId(null);
  };

  const handleClose = () => {
    resetForm();
    setIsModalOpen("");
  };

  const handleSubmitClick = () => {
    handleSubmit(modalAction, remarks, selectedApproverId);
    resetForm();
    handleClose();
  };

  return (
    <Modal
      open={Boolean(modalAction)}
      onClose={handleClose}
      aria-labelledby="modal-approval-title"
      aria-describedby="modal-approval-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: 2,
          p: 4,
        }}
      >
        <Stack direction="column" spacing={2}>
          <Typography variant="h5" component="h5">
            Update Status
          </Typography>

          {modalAction === "assign-approver" && (
            <>
              {isEmployeeDataLoading ? (
                <CircularProgress size={24} sx={{ alignSelf: "center" }} />
              ) : isEmployeeDataError ? (
                <Alert
                  severity="error"
                  action={
                    <Button
                      color="inherit"
                      size="small"
                      onClick={employeeDataRefetch}
                    >
                      Retry
                    </Button>
                  }
                >
                  Failed to load employees
                </Alert>
              ) : (
                <FormControl fullWidth>
                  <InputLabel id="approver-select-label">
                    Whom do you want to assign it?
                  </InputLabel>
                  <Select
                    labelId="approver-select-label"
                    value={selectedApproverId}
                    label="Whom do you want to assign it?"
                    onChange={(e) =>
                      setSelectedApproverId(e.target.value as string)
                    }
                  >
                    {employeeData?.select_employee?.map((emp) => (
                      <MenuItem key={emp?.EMPLOYEE_ID} value={emp?.USERNAME}>
                        {emp?.USERNAME}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            </>
          )}

          <TextField
            fullWidth
            multiline
            minRows={3}
            label="Remarks"
            inputProps={{ maxLength: 200 }}
            variant="outlined"
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
          />
        </Stack>

        <Stack direction="row" spacing={2} justifyContent="flex-end" mt={3}>
          <Button variant="outlined" size="small" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={handleSubmitClick}
            disabled={
              (modalAction === "assign-approver" &&
                (!remarks.trim() ||
                  !selectedApproverId ||
                  isEmployeeDataLoading ||
                  isEmployeeDataError)) ||
              !remarks.trim()
            }
          >
            {modalAction === "Approved"
              ? "Approve"
              : modalAction === "Rejected"
              ? "Reject"
              : modalAction === "Pending Rework"
              ? "Send Back"
              : modalAction === "assign-approver"
              ? "Send & Assign"
              : "Submit"}
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default ApproverModal;
